module.exports = __webpack_public_path__ + "static/media/project-img6.a8813a62.png";